<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.271"
    height="14.939"
    viewBox="0 0 25.271 14.939"
  >
    <g transform="translate(-262.925 -429.611)">
      <g>
        <g>
          <path
            d="M263.842,441.4a1.421,1.421,0,0,1-.783-.638,1.976,1.976,0,0,1,.305-1.956,2.454,2.454,0,0,0,.3-1.85,2.528,2.528,0,0,1,.131-1.562,24.413,24.413,0,0,0,.9-2.352c-.034-.385-.052-1.372.6-1.77.449-.277,1.032-.177,1.74.306.222.152.438.3.646.451,1.639,1.165,2.411,1.627,3.477.387.3-.352.588-.726.857-1.078.835-1.094,1.439-1.884,2.2-1.7.634.162.9.965,1.056,1.8,1.5.669,5.142,1.973,5.887,2.243a12.055,12.055,0,0,1,3.983-.139,2.8,2.8,0,0,1,2.087,1.659,2.257,2.257,0,0,1-.561,2.163c-1.311,1.639-2.726,3.056-6.789,3.766-4.006.7-13.359.561-14.722.491A4.393,4.393,0,0,1,263.842,441.4Zm2.207-9.232a.4.4,0,0,0-.224-.043,1.436,1.436,0,0,0-.114.908l-.021.219a26.5,26.5,0,0,1-.981,2.556,1.627,1.627,0,0,0-.052,1,3.4,3.4,0,0,1-.431,2.5c-.394.674-.321.919-.289.977.046.086.264.29,1.267.343,1.348.07,10.576.2,14.5-.476,3.725-.651,4.957-1.874,6.182-3.411a1.355,1.355,0,0,0,.39-1.232,1.877,1.877,0,0,0-1.334-.989,11.122,11.122,0,0,0-3.715.168l-.139.029-.132-.051c-.2-.075-4.849-1.723-6.342-2.434l-.237-.112-.042-.258c-.179-1.094-.383-1.263-.391-1.271a9.8,9.8,0,0,0-1.126,1.348c-.28.365-.579.756-.894,1.123-1.706,1.98-3.287.858-4.812-.224-.2-.144-.414-.293-.631-.44a2.156,2.156,0,0,0-.432-.229Z"
            fill="#777"
          />
          <path
            d="M264.036,438.707l.14-.991a110.7,110.7,0,0,0,11.966,1.02c3.818-.116,7.415-1.249,8.522-2.7a8.484,8.484,0,0,1,1.559-1.827l.664.749a7.647,7.647,0,0,0-1.4,1.65c-1.545,2.022-5.8,3.021-9.34,3.125A111.884,111.884,0,0,1,264.036,438.707Z"
            fill="#777"
          />
          <path
            d="M276.952,435.231q-1.162-.447-2.265-.987l.44-.9a27.045,27.045,0,0,0,4.481,1.72q.041,0,.081,0a.844.844,0,0,0,.874-.812v0h0l1,.029a1.846,1.846,0,0,1-1.9,1.791h0a1.775,1.775,0,0,1-.282-.031Q278.133,435.682,276.952,435.231Z"
            fill="#777"
          />
        </g>
        <rect
          width="1"
          height="2.236"
          transform="matrix(0.738, -0.675, 0.675, 0.738, 285.95, 438.047)"
          fill="#777"
        />
        <rect
          width="1"
          height="2.236"
          transform="matrix(0.738, -0.675, 0.675, 0.738, 284.3, 439.556)"
          fill="#777"
        />
        <rect
          width="1"
          height="2.828"
          transform="translate(281.986 439.639) rotate(-24)"
          fill="#777"
        />
        <rect
          width="1"
          height="2.5"
          transform="translate(279.846 440.901) rotate(-15.87)"
          fill="#777"
        />
      </g>
      <rect
        width="25"
        height="1"
        transform="translate(263.085 443.55)"
        fill="#777"
      />
    </g>
  </svg>
</template>
